import { render, staticRenderFns } from "./QuestionFrom.vue?vue&type=template&id=52b94fa2&scoped=true&"
import script from "./QuestionFrom.vue?vue&type=script&lang=ts&"
export * from "./QuestionFrom.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionFrom.vue?vue&type=style&index=0&id=52b94fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b94fa2",
  null
  
)

export default component.exports